class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.hoverTimeout = null;

    // Add hover events ONLY for header-menu
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    
    // Also listen for mouse enter/leave on the content for mega menus
    if (this.content) {
      this.content.addEventListener('mouseenter', this.onContentMouseEnter.bind(this));
      this.content.addEventListener('mouseleave', this.onContentMouseLeave.bind(this));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

 
  onMouseEnter() {
    // Clear any pending close timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    
    // Only open if not already open
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.mainDetailsToggle.dispatchEvent(new Event('toggle'));
    }
  }

  onContentMouseEnter() {
    // Clear any pending close timeout when mouse enters the content
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  onContentMouseLeave() {
    // Start the close timeout when mouse leaves the content
    this.startCloseTimeout();
  }

  onMouseLeave() {
    // Don't close immediately - start a timeout
    this.startCloseTimeout();
  }

  startCloseTimeout() {
    // Clear any existing timeout
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
    
    // Set a new timeout to check if we should close
    this.hoverTimeout = setTimeout(() => {
      // Check if mouse is anywhere in the header-menu component OR in the content
      const isMouseInComponent = this.matches(':hover');
      const isMouseInContent = this.content && this.content.matches(':hover');
      
      // Also check if any element in the dropdown has focus
      const hasFocus = this.contains(document.activeElement) || 
                      (this.content && this.content.contains(document.activeElement));
      
      // Only close if mouse is not in component and not in content and no focus
      if (!isMouseInComponent && !isMouseInContent && !hasFocus) {
        this.close();
      }
    }, 400); // 400ms delay to allow moving to dropdown
  }

  // Override close to clear timeout
  close() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
    
    super.close();
  }
}

customElements.define('header-menu', HeaderMenu);
